export default "__VITE_ASSET__CzTfmpYR__"